import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "@assets/icons/icons";
import { FOOTER_NAVIGATION } from "@constants/footer";

function FooterLinks({ title, links }) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      <ul role="list" className="mt-6 space-y-4">
        {links.map((item) => (
          <li key={item.name}>
            <Link
              to={item.href}
              className="text-sm leading-6 text-muted-foreground hover:text-primary transition-colors"
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

function FooterSocial() {
  return (
    <div className="flex space-x-4 sm:space-x-6">
      {FOOTER_NAVIGATION.social.map((item) => (
        <a
          key={item.name}
          href={item.href}
          aria-label={item.name}
          className="text-muted-foreground hover:text-primary transition-colors"
        >
          <item.icon className="h-5 w-5 sm:h-6 sm:w-6" />
        </a>
      ))}
    </div>
  );
}

function FooterNewsletter() {
  return (
    <div>
      <h3 className="text-sm font-semibold text-foreground">Newsletter</h3>
      <p className="mt-2 text-sm leading-6 text-muted-foreground">
        Subscribe to our newsletter for the latest job updates and career tips.
      </p>
      <form
        className="mt-4 sm:flex sm:max-w-md"
        aria-label="Subscribe to newsletter"
      >
        <label htmlFor="email-address" className="sr-only">
          Email address
        </label>
        <input
          type="email"
          name="email-address"
          id="email-address"
          autoComplete="email"
          required
          className="w-full min-w-0 rounded-md border-0 bg-background px-3 py-2 text-sm text-foreground shadow-sm ring-1 ring-inset ring-border placeholder:text-muted-foreground focus:ring-2 focus:ring-primary sm:w-64 xl:w-full"
          placeholder="Enter your email"
        />
        <div className="mt-3 sm:ml-3 sm:mt-0 sm:flex-shrink-0">
          <button
            type="submit"
            className="flex w-full items-center justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-primary-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary transition-colors"
          >
            Subscribe
          </button>
        </div>
      </form>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="bg-card border-t" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 py-6 sm:py-20 lg:px-8 lg:py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {/* Company Info */}
          <div className="space-y-8">
            <div>
              <Link to="/" className="flex items-center space-x-2">
                <img
                  src="/logo.png"
                  alt="UdyogVriksh"
                  className="h-10 w-auto"
                />
              </Link>
              <p className="mt-4 text-sm leading-6 text-muted-foreground">
                Bridging the gap between degrees and careers. We equip you with real-world skills, mentorship, and opportunities to crack your dream tech job.
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="h-4 w-4 text-primary" /> contact@udyogvriksh.in
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="h-4 w-4 text-primary" /> +91 98765 43210
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4 text-primary" /> Bangalore,
                Karnataka, India
              </div>
            </div>

            <FooterSocial />
          </div>

          {/* Links + Newsletter */}
          <div className="mt-12 lg:mt-0 grid grid-cols-1 md:grid-cols-2 gap-12 lg:col-span-2">
            <div className="grid grid-cols-2 gap-8">
              <FooterLinks title="Company" links={FOOTER_NAVIGATION.company} />
              <FooterLinks
                title="Resources"
                links={FOOTER_NAVIGATION.resources}
              />
            </div>
            <FooterNewsletter />
          </div>
        </div>

        <div className="mt-12 sm:mt-16 border-t pt-6 sm:pt-8">
          <p className="text-xs sm:text-sm text-muted-foreground text-center">
            &copy; {new Date().getFullYear()} UdyogVriksh. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
